import { excludedCurrencies } from '../config/constants';

export default class CurrencyExchangeClient {
    constructor(commonHttpFactory, httpCacheFactory, $q, router) {
        this.PAYSERA_DOMAIN = `https://${webpack_env.payseraBankDomain}`;
        this.$q = $q;
        this.router = router;
        this.httpCache = httpCacheFactory.createHttpCache('currency_exchange');
        this.commonHttp = commonHttpFactory.createCommonHttp(
            {
                error_context: 'currency_exchange',
                success_context: 'currency_exchange'
            },
            this.httpCache
        );

        this.rates = {};
    }

    isCurrencySupported(currency) {
        return !excludedCurrencies.includes(currency);
    }

    getSupportedCurrencies(parameters, error_context) {
        return this.commonHttp
            .get(this.PAYSERA_DOMAIN
                + `/${encodeURIComponent(parameters.locale)}`
                + '/currency-exchange/rest/supported-currencies',
                {
                    error_context: error_context ? error_context : null
                }
            ).then((response) => {
                return response.currencies.filter(this.isCurrencySupported);
            });
    }

    getDefaultCountryCurrency(parameters, error_context) {
        return this.commonHttp
            .get(this.PAYSERA_DOMAIN
                + `/${encodeURIComponent(parameters.locale)}`
                + '/currency-exchange/rest/country-default-currency',
                {
                    error_context: error_context ? error_context : null,
                    params: {
                        country_code: parameters.country_code
                    }
                }
            ).then((response) => {
                return response.currency;
            });
    }

    getSupportedProviders(parameters, error_context) {
        return this.commonHttp
            .get(this.PAYSERA_DOMAIN
                + `/${encodeURIComponent(parameters.locale)}`
                + '/currency-exchange/rest/country-supported-providers',
                {
                    error_context: error_context ? error_context : null,
                    params: {
                        country_code: parameters.country_code
                    }
                }
            ).then((response) => {
                return response.providers;
            });
    }

    convertCurrency(parameters, error_context) {
        var params = {};

        if (parameters.from_currency) {
            params['from_currency[]'] = parameters.from_currency;
        }

        if (parameters.to_currency) {
            params['to_currency[]'] = parameters.to_currency;
        }

        if (parameters.from_amount) {
            params.from_amount = parameters.from_amount;
        }

        if (parameters.to_amount) {
            params.to_amount = parameters.to_amount;
        }

        if (parameters.providers) {
            params['providers[]'] = parameters.providers;
        }
        if (parameters.clientType) {
            params['clientType'] = parameters.clientType;
        }

        if (parameters.country_code) {
            params.country_code = parameters.country_code;
        }

        return this.commonHttp
            .get(this.PAYSERA_DOMAIN
                + `/${encodeURIComponent(parameters.locale)}`
                + '/currency-exchange/rest/convert',
                {
                    error_context: error_context ? error_context : null,
                    params: params
                }
            ).then((response) => {
                return response.rates;
            });
    }

    getCurrencyTranslations(locale) {
        return this.commonHttp
            .get(
                this.router.generate(
                    'paysera_currency_exchange.currencies',
                    {
                        '_locale': locale
                    }
                ),
                {
                    cache: true
                }
            );
    }
}

CurrencyExchangeClient.$inject = ['commonHttpFactory', 'httpCacheFactory', '$q', 'router'];
